import algoliasearch from 'algoliasearch'
import { reverseGeocode } from '@lib/geo-api'

const searchClient = algoliasearch(
  process.env.ALGOLIA_APP_ID,
  process.env.ALGOLIA_API_KEY,
)

/**
 * Visitor coordinates from Algolia `aroundLatLngViaIP` (hitsPerPage 0).
 * Does not wait on Coach Tools reverse-geocode — callers that need a
 * City, ST label should follow with `placeNameFromAroundLatLng`.
 */
export async function detectAroundLatLngFromIp() {
  const { aroundLatLng } = await searchClient
    .initIndex(process.env.ALGOLIA_COACH_INDEX_NAME)
    .search('', {
      aroundLatLngViaIP: true,
      hitsPerPage: 0,
    })
  return aroundLatLng || null
}

export async function placeNameFromAroundLatLng(aroundLatLng) {
  if (!aroundLatLng) return null
  const geo = await reverseGeocode(aroundLatLng)
  if (!geo?.city || !geo?.state) return null
  return `${geo.city}, ${geo.state}`
}

/**
 * Turn the visitor's IP into a City, ST.
 * Algolia `aroundLatLngViaIP` (hitsPerPage 0) yields coordinates; Coach Tools
 * reverse-geocode supplies city and state. `/coach` and `/golf-lessons` hydrate
 * Near this way. The coach directory pins InstantSearch from
 * `detectAroundLatLngFromIp` first so cards can paint, then fills the Near
 * label with `placeNameFromAroundLatLng`. Returns null when Algolia or
 * reverse-geocode cannot resolve.
 */
export async function detectLocationFromIp() {
  const aroundLatLng = await detectAroundLatLngFromIp()
  if (!aroundLatLng) return null
  const placeName = await placeNameFromAroundLatLng(aroundLatLng)
  if (!placeName) return null
  return {
    placeName,
    aroundLatLng,
  }
}

export const detectJourneyLocationFromIp = detectLocationFromIp
